import { AxiosPromise } from 'axios'
import { http } from '@/api/httpAxios'

export default class CounterAPI {
  public static getFloatButtonCount(): AxiosPromise {
    return http.get('/counter/common')
  }
}
